import React, { useReducer } from 'react';
import PaisContext from './paisContext';
import PaisReducer from './paisReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_PAISES,
    AGREGAR_PAIS,
    ELIMINAR_PAIS,
    ACTUALIZAR_PAIS,
    PAIS_ERROR,
    PAIS_OK,
    PAIS_ACTUAL,
} from 'types/context';

const PaisState = props => {
    const initialState = {
        paises: [],
        pais: null,
        formulario: false,
        errorformulario: false,
        mensaje: null
    }

    const [state, dispatch] = useReducer(PaisReducer, initialState);

    // Obtener los paises
    const obtenerPaises = async() => {
        try {
            const resultado = await clienteAxios.get('/paises');
            dispatch({
                type: OBTENER_PAISES,
                payload: resultado.data.paises
            })
            return resultado.data.paises.rows
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: PAIS_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo pais
    const agregarPais = async pais => {

            try {
                const resultado = await clienteAxios.post('/paises', pais);
                //console.log(resultado);
                // Insertar el pais en el state
                dispatch({
                    type: AGREGAR_PAIS,
                    payload: resultado.data.pais
                })
                const alerta = {
                    msg: "Pais creado con exito",
                    categoria: 'exito'
                }
                dispatch({
                    type: PAIS_OK,
                    payload: alerta
                })
            } catch (error) {
                const alerta = {
                    msg: error.response.data.message,
                    categoria: 'error'
                }
                dispatch({
                    type: PAIS_ERROR,
                    payload: alerta
                })
            }
        }
        // Selecciona el Pais que el usuario dio click
    const paisActual = paisId => {
        dispatch({
            type: PAIS_ACTUAL,
            payload: paisId
        })
    }

    // Elimina un pais
    const eliminarPais = async paisId => {
        try {
            await clienteAxios.delete(`/paises/${paisId}`);
            dispatch({
                type: ELIMINAR_PAIS,
                payload: paisId
            })
            const alerta = {
                msg: "Pais eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PAIS_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: PAIS_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar pais
    const actualizarPais = async pais => {

        try {
            const resultado = await clienteAxios.put(`/paises/${pais.id}`, pais);
            //console.log(resultado);
            // Actualizo el pais en el state
            dispatch({
                type: ACTUALIZAR_PAIS,
                payload: resultado.data.pais
            })
            const alerta = {
                msg: "Pais actualizado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: PAIS_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: PAIS_ERROR,
                payload: alerta
            })
        }
    }

    // muestra un error de validacion
    const errorPais = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: PAIS_ERROR,
            payload: alerta
        })
    }

    const OkPais = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: PAIS_OK,
            payload: alerta
        })
    }
    const clearErrorPais = () => {
        dispatch({
            type: PAIS_ERROR,
            payload: null,
        });
        };

    const clearOkPais = () => {
        dispatch({
            type: PAIS_OK,
            payload: null,
        });
    }

    return ( <PaisContext.Provider value = {
            {
                paises: state.paises,
                pais: state.pais,
                formulario: state.formulario,
                errorformulario: state.errorformulario,
                mensaje: state.mensaje,
                obtenerPaises,
                agregarPais,
                paisActual,
                eliminarPais,
                actualizarPais,
                errorPais,
                OkPais,
                clearErrorPais,
                clearOkPais
            }
        } >
        { props.children }

        </PaisContext.Provider>
    )
}
export default PaisState;